import React from 'react';
import ComboBox from 'components/combo-box';
import Col from 'components/col';

module.exports = React.createClass({

  render(){
    var className = ((this.props.className) || 'form-control');
    return (
      <Col size={this.props.size} className='form-group'>
        <label>{this.props.label}</label>
        <ComboBox {...this.props} className={className}/>
      </Col>
    );
  }

});


/** WEBPACK FOOTER **
 ** ./src/components/form-combo-box.js
 **/